import React from 'react';

const marker = (
	<g transform="translate(6.000000, 6.000000)">
		<rect fill="#AFE6FF" x="0" y="0" width="20" height="20" rx="10"/>
		<rect fill="#2FBEFF" x="2" y="2" width="16" height="16" rx="8"/>
		<path
			d="M7.61818182,6.95 L6.80454545,6.13181818 L6.16363636,6.77272727 L6.98181818,7.58636364 L7.61818182,6.95 Z M5,10.4545455 L6.36363636,10.4545455 L6.36363636,9.54545455 L5,9.54545455 L5,10.4545455 Z M8.63636364,14.5227273 L11.3636364,14.5227273 L11.3636364,12.3363636 C12.1772727,11.8636364 12.7272727,10.9863636 12.7272727,9.97727273 C12.7272727,8.47272727 11.5045455,7.25 10,7.25 C8.49545455,7.25 7.27272727,8.47272727 7.27272727,9.97727273 C7.27272727,10.9863636 7.82272727,11.8636364 8.63636364,12.3363636 L8.63636364,14.5227273 Z M9.54545455,11.8136364 L9.09090909,11.55 C8.52727273,11.2227273 8.18181818,10.6227273 8.18181818,9.97727273 C8.18181818,8.97272727 8.99545455,8.15909091 10,8.15909091 C11.0045455,8.15909091 11.8181818,8.97272727 11.8181818,9.97727273 C11.8181818,10.6227273 11.4686364,11.2227273 10.9090909,11.55 L10.4545455,11.8136364 L10.4545455,13.6136364 L9.54545455,13.6136364 L9.54545455,11.8136364 Z M13.6363636,10.4545455 L15,10.4545455 L15,9.54545455 L13.6363636,9.54545455 L13.6363636,10.4545455 Z M9.54545455,6.36363636 L10.4545455,6.36363636 L10.4545455,5 L9.54545455,5 L9.54545455,6.36363636 Z M13.8409091,6.77727273 L13.2,6.13636364 L12.3863636,6.95454545 L13.0272727,7.59545455 L13.8409091,6.77727273 Z"
			fill="#FFFFFF"/>
	</g>
);

const LightMarkers = () => (
	<g id="lightMarkers" transform="translate(791.000000, 604.000000)">
		<g transform="translate(0.000000, 383.000000)">{marker}</g>

		<g id="ic-light" transform="translate(485.000000, 59.000000)">
			{marker}
		</g>
		<g id="ic-light" transform="translate(319.000000, 0.000000)">
			{marker}
		</g>
		<g id="ic-light" transform="translate(332.000000, 205.000000)">
			{marker}
		</g>
		<g id="ic-light" transform="translate(164.000000, 206.000000)">
			{marker}
		</g>
		<g id="ic-light" transform="translate(485.000000, 238.000000)">
			{marker}
		</g>
		<g id="ic-light" transform="translate(1232.000000, 502.000000)">
			{marker}
		</g>
		<g id="ic-light" transform="translate(1055.000000, 427.000000)">
			{marker}
		</g>
		<g id="ic-light" transform="translate(1521.000000, 542.000000)">
			{marker}
		</g>
		<g id="ic-light" transform="translate(1395.000000, 511.000000)">
			{marker}
		</g>
		<g id="ic-light" transform="translate(1236.000000, 395.000000)">
			{marker}
		</g>
		<g id="ic-light" transform="translate(1193.000000, 395.000000)">
			{marker}
		</g>
		<g id="ic-light" transform="translate(354.000000, 236.000000)">
			{marker}
		</g>
		<g id="ic-light" transform="translate(119.000000, 275.000000)">
			{marker}
		</g>
		<g id="ic-light" transform="translate(255.000000, 441.000000)">
			{marker}
		</g>
		<g id="ic-light" transform="translate(754.000000, 463.000000)">
			{marker}
		</g>
	</g>
);

export default LightMarkers;
